/** Single sink for client-side errors. Always logs to the console; also forwards
 * to the Sentry browser SDK if one has been installed on `window` (so wiring
 * Sentry later — see docs/architecture/infrastructure/observability.md — needs
 * no change here).
 * Intentionally dependency-free and never throws. */
type SentryLike = {
  captureException?: (error: unknown, context?: unknown) => void;
};

export function reportClientError(
  error: unknown,
  context?: Record<string, unknown>,
): void {
  console.error("[graphmind] client error", error, context ?? "");
  try {
    const sentry = (window as unknown as { Sentry?: SentryLike }).Sentry;
    sentry?.captureException?.(error, context ? { extra: context } : undefined);
  } catch {
    /* reporting must never mask the original error */
  }
}
